import { render, staticRenderFns } from "./historicalValue.vue?vue&type=template&id=12063cb8&scoped=true&"
import script from "./historicalValue.vue?vue&type=script&lang=js&"
export * from "./historicalValue.vue?vue&type=script&lang=js&"
import style0 from "./historicalValue.vue?vue&type=style&index=0&id=12063cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12063cb8",
  null
  
)

export default component.exports